export interface PriceGroupDetailServerItem {
  scan_code?: string;
  item_name?: string;
  department_name?: string;
  retail_price?: string;
}

export interface PriceGroupDetailServerData {
  pricegroup?: {
    name?: string;
    value?: string;
  } | null;
  items?: PriceGroupDetailServerItem[] | null;
}

export interface PriceGroupDetailItem {
  scanCode: string;
  itemName: string;
  departmentName: string;
  retailPrice: string;
}

export interface PriceGroupDetailInfo {
  name: string;
  value: string;
}

export class PriceGroupDetailModel {
  private readonly _priceGroup: PriceGroupDetailInfo;
  private readonly _items: PriceGroupDetailItem[];

  constructor(serverData: PriceGroupDetailServerData | null | undefined) {
    this._priceGroup = {
      name: String(serverData?.pricegroup?.name ?? '').trim(),
      value: String(serverData?.pricegroup?.value ?? '').trim(),
    };

    const items = Array.isArray(serverData?.items) ? serverData?.items ?? [] : [];

    this._items = items.map((item) => ({
        scanCode: String(item?.scan_code ?? '').trim(),
        itemName: String(item?.item_name ?? '').trim(),
        departmentName: String(item?.department_name ?? '').trim(),
        retailPrice: String(item?.retail_price ?? '').trim(),
    }));
  }

  static fromServerData(serverData: PriceGroupDetailServerData | null | undefined): PriceGroupDetailModel {
    return new PriceGroupDetailModel(serverData);
  }

  getPriceGroup(): PriceGroupDetailInfo {
    return this._priceGroup;
  }

  getItems(): PriceGroupDetailItem[] {
    return this._items;
  }
}
